var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PureComponent } from 'react';
import { ContactIsTypingIndicator } from './components/ContactIsTypingIndicator';
import { DirectionIcon } from './components/DirectionIcon';
import { CONVERSATION_DIRECTION_INBOUND, CONVERSATION_STATUS_ACTIVE, CONVERSATION_STATUS_AWAITING_PENDING, CONVERSATION_STATUS_NONE, CONVERSATION_STATUS_PENDING, } from './constants';
import styles from './styles.module.scss';
const ICON_MAPPING = {
    pstnphone: 'phone',
    email: 'mail',
    widgetchat: 'chat',
    messenger: 'messenger',
    facebookmessenger: 'facebook-messenger',
    whatsapp: 'whatsapp',
    sms: 'sms',
    callback: 'phone-plus',
    voicemail: 'voicemail',
    contactform: 'chat-widget',
    twitter: 'twitter',
};
export class ConversationStatusIcon extends PureComponent {
    render() {
        const _a = this.props, { className, channel, direction, status, loading, typing, unreadCount, large } = _a, otherProps = __rest(_a, ["className", "channel", "direction", "status", "loading", "typing", "unreadCount", "large"]);
        const rootClass = this.getRootClassName(status, loading, large, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [typing ? (_jsx(ContactIsTypingIndicator, {})) : (_jsx(Icon, { className: styles.icon, name: ICON_MAPPING[channel !== null && channel !== void 0 ? channel : 'sms'] })), _jsx(DirectionIcon, { direction: direction, size: this.getDirectionIconSize(large) })] })));
    }
    getRootClassName(status, loading, large, className) {
        return classnames({
            [styles.root]: true,
            [styles.rootActive]: status === CONVERSATION_STATUS_ACTIVE,
            [styles.rootFollowUp]: this.hasFollowup(status),
            [styles.rootLoading]: loading,
            [styles.rootLarge]: large,
        }, className);
    }
    getDirectionIconSize(large) {
        return large ? '21' : '13';
    }
    hasFollowup(status) {
        return (status === CONVERSATION_STATUS_PENDING ||
            status === CONVERSATION_STATUS_AWAITING_PENDING);
    }
}
ConversationStatusIcon.defaultProps = {
    direction: CONVERSATION_DIRECTION_INBOUND,
    status: CONVERSATION_STATUS_NONE,
};
